import webapp from '@/services/webapp'
import { useDeviceSettings } from '@/composables/settings'

export const useHapticFeedback = () => {
  const { gameDeviceSettings } = useDeviceSettings()

  function addHapticFeedback(style: 'light' | 'medium' | 'heavy' = 'heavy') {
    if (gameDeviceSettings.value.hapticFeedback) {
      webapp.hapticFeedbackImpact(style)
    }
  }

  return {
    addHapticFeedback,
  }
}